<template>
  <div class="xsd_midresult">
    <div class="top_container">
      <div class="normal top_container_inner">
        <div style="align-items: center;font-size: 28px;font-weight: bold;color:rgba(0,0,0,0.85)">
          恭喜您完成本次检查
        </div>
        <div style="display: flex;margin-top: 5px;">
          <div style="height: 10px; background-color:#D6DEEE;border-radius: 5px;margin-top: 5px;flex:1;">
            <div :style="{
                        backgroundColor:'#224AE3'
                      }" style=" height: 10px;border-radius: 5px;width: 100%;">
            </div>
          </div>
          <div style="font-size: 16px;margin-left: 16px;">100%</div>
        </div>
      </div>
    </div>
    <div class="body_container body_container_err">
      <img alt="" src="~@/assets/image/bg2.png">
      <div style="font-size: 14px;margin-top: 16px">
        <span>充值查看结果。</span>
      </div>
      <div v-if="deduction" style="text-align: center;margin-top: 15px;font-size: 14px;">
        已完成充值，正在跳转结果页面……({{ time }}s)
      </div>
      <div style="margin-top: 16px;text-align: center;display: flex;" v-else>
        <div class="refresh" @click="refresh">刷新</div>
        <div
            class="Invest" style="margin-left: 16px;" @click="goInvest" v-tracking="{module:'xsd_pdf',actionName: $trackConfig['xsd_pdf_invest'],actionCode:'xsd_pdf_invest'}">去充值
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import {checkDeduction,getResultHead} from "@/api/common";

export default {
  name: "middleResult",
  data(){
    return{
      time:5,
      timer1:null,
      deduction:false
    }
  },
  async mounted() {
    await  this.checkDeduction();
  },
  methods: {
    refresh() {
      location.reload();
    },
    goInvest() {
      let data = {
        source: "similarity",
        info: {
          actionType: 2 //  1需要充值
        }
      };
      window.parent.postMessage(JSON.stringify(data), "*");
    },
    async checkDeduction(){
      let res = await checkDeduction({
        project: this.projectId,
        sign_name: this.sign_name,
      });
      if(res.data){
        await this.getResultHead();
        this.timer1 = setInterval(() => {
          this.time = this.time - 1
        }, 1000);
        this.deduction = true;
      }else{
        this.deduction = false;
      }

    },
    async getResultHead(){
      let res = await getResultHead({
        project: this.projectId,
        sign_name: this.sign_name,
      });
      this.setEvaluationData_pdf(res.data.resultHead.evaluation);
    },
    ...mapMutations("pdf",{
      setProcessData_pdf:"setProcessData",
      setEvaluationData_pdf:"setEvaluationData",
      set_projectId_pdf:"set_projectId_pdf",
      set_signName_pdf:"set_signName_pdf"
    })
  },
  computed: {
    ...mapState('pdf', ['sign_name', 'projectId']),
    ...mapState("user",[ 'serviceInfo'])
  },
  watch: {
    time(val) {
      if (val == 0) {
        clearInterval(this.timer1);
        this.$router.push('/pdfResult')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.xsd_midresult {
  height: 100%;
  width: 100%;
  background-color: #F4F7F9;
  display: flex;
  flex-direction: column;
  background-size: 100% 240px;
  background-repeat: no-repeat;
  background-image: url("~@/assets/image/topbg1.png");
  //align-items: center;
  //justify-content: center;
  .top_container {
    height: 150px;

    .normal {
      background-image: url("~@/assets/image/normal.gif");
      background-repeat: no-repeat;
      mix-blend-mode: darken;
      background-size: 150px;
    }

    .warning {
      background-image: url("~@/assets/image/warning.gif");
      background-repeat: no-repeat;
      mix-blend-mode: darken;
      background-size: 150px;
    }

    .top_container_inner {
      height: 150px;
      display: flex;
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      padding-left: 150px;
      flex-direction: column;
      justify-content: center;
      box-sizing: border-box;

    }
  }

  .body_container {
    flex: 1;
    width: 1200px;
    margin: 16px auto;
    background-color: #fff;
    box-sizing: border-box;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .refresh {
      width: 60px;
      height: 28px;
      font-size: 14px;
      border: 1px solid rgba(34, 74, 227, 1);
      text-align: center;
      line-height: 28px;
      background-color: #fff;
      cursor: pointer;
      border-radius: 4px;
      color: #224AE3;

    }

    .Invest {
      width: 60px;
      height: 30px;
      font-size: 14px;
      text-align: center;
      line-height: 28px;
      background-color: #224AE3;
      cursor: pointer;
      border-radius: 4px;
      color: #FFF;
    }

    .resBtn {
      width: 90px;
      height: 30px;
      font-size: 14px;
      text-align: center;
      line-height: 28px;
      background-color: #224AE3;
      cursor: pointer;
      border-radius: 4px;
      color: #FFF;
    }
  }
}

.red {
  color: #F53F3F;
}

.green {
  color: #00B42A;
}
</style>
